import { render } from "./AppStartTransition.vue?vue&type=template&id=164288ae&scoped=true"
import script from "./AppStartTransition.vue?vue&type=script&lang=js"
export * from "./AppStartTransition.vue?vue&type=script&lang=js"

import "./AppStartTransition.vue?vue&type=style&index=0&id=164288ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-164288ae"]])

export default __exports__